<template>
  <div class="paymentFailledWrapper whitePMbg">
    <b-row>
      <b-col cols="12">
        <div class="pmstatusIcon floatCss">
          <img :src="stsFailedImg">
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="paymentfailledTop floatCss">
          <h1>Payment failed</h1>
          <p>{{ failureMessage }}</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="startBtnpm floatCss">
          <b-button
            class="sts-pm-btn"
            :to="{ name: 'sales-payment-frontend-review', params: { token: $route.params.token } }"
          >
            Try again
          </b-button>
        </div>
        <div class="backRevBtnpm floatCss">
          <b-button
            class="rev-pm-btn"
            :to="{ name: 'sales-payment-frontend-review', params: { token: $route.params.token } }"
          >
            Back to review payment
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },

  data() {
    return {
      // eslint-disable-next-line global-require
      stsFailedImg: require('@/assets/images/mobile/stsFailled.png'),
      // Only ever set for a same-session redirect straight from the card charge attempt
      // (SalesPaymentCardForm.vue) - a real, specific reason (e.g. an Omise error like the
      // S$20,000 charge limit) when available. Not part of the URL, so it's gone on a refresh or
      // a direct link to this page - the generic fallback covers that case, same wording as before
      // this page could show anything more specific.
      defaultMessage: 'Payment was unsuccessful. Your credit card was not charged. Please select other payment mode or try again.',
    }
  },
  computed: {
    failureMessage() {
      return this.$route.params.message || this.defaultMessage
    },
  },
}
</script>
